import Link from 'next/link'
import Image from 'next/image'

type Props = {
  blog: any
  priority?: boolean
}

export default function BlogCard({ blog, priority = false }: Props) {
  return (

    <article className="border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
      {blog.image && (
        <div className="relative overflow-hidden h-48 sm:h-56 md:h-64 w-full">
          <Image
            src={blog.image}
            alt={blog.title}
            fill
            priority={priority}
            quality={80}
            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
            className="object-cover transition-transform duration-300 hover:scale-110"
          />
        </div>
      )}
      <div className="p-4 sm:p-6">
        <h2 className="text-lg sm:text-xl font-semibold line-clamp-2">{blog.title}</h2>
        <p className="text-sm text-gray-600 mt-2 line-clamp-3">{blog.excerpt}</p>
        <div className="mt-4">
          <Link
            href={`/blogs/${blog.slug}`}
            className="text-[#0066CC] hover:text-[#004BA6] font-semibold transition-colors inline-flex items-center gap-2"
          >
            Weiterlesen
            <span>→</span>
          </Link>
        </div>
      </div>
    </article>
  )
}
